import effects from './effects';
import * as reducer from './reducer';
import namespace from './namespace';
import NewLocation from './containers/NewLocation';

export { effects, reducer, namespace };
export default NewLocation;
